import {AfterContentChecked, ChangeDetectorRef, Component, ElementRef, ViewChild, ViewEncapsulation} from '@angular/core';
import { AlertController, Animation, AnimationController, GestureController, GestureDetail, IonContent, IonFooter, IonHeader, Platform } from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import { EMPTY } from 'rxjs';
import { finalize, mergeMap} from 'rxjs/operators';

import {FCMService} from 'shared/fcm/fcm.service';
import {getTranslation} from 'shared/helpers/get-translation';
import {NavService} from 'shared/nav/nav.service';

import {BadgeService} from 'app/badge';
import {ContentService} from 'app/content';
import {Dialog, DialogGroups, DialogsService, DialogStats, ThesesStats} from 'app/dialogs';
import {UserService} from 'app/profile';
import {UserContent, UserProfile} from 'app/profile/model/model';
import {PODCAST_TYPE, TIP_TYPE, TipService, VIDEO_TYPE} from 'app/tips';
import {Daytime, DaytimeService, InteractionService, QuestionTime} from 'shared/daytime';

import { ActionPerformed, PushNotificationSchema } from '@capacitor/push-notifications';

import { App } from '@capacitor/app';

import {ActivatedRoute} from '@angular/router';

import { Gesture, GestureConfig, createGesture } from '@ionic/core';
import { SwiperComponent } from 'swiper/angular';

// import Swiper core and required components
import SwiperCore, {
  A11y,
  Keyboard,
  Mousewheel,
  Navigation,
  Pagination,
} from "swiper/core";

// install Swiper components
SwiperCore.use([A11y, Keyboard, Mousewheel, Navigation, Pagination]);

import { LaunchReview } from '@awesome-cordova-plugins/launch-review/ngx';
import { LocalSettingsService } from 'shared/local-settings/local-settings.service';

const INDEX_FORMAT: string = 'MM-DD-YYYY';

@Component({
  selector: 'dashboard-page',
  templateUrl: 'dashboard-page.html',
  styleUrls: ['dashboard-page.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardPage implements AfterContentChecked {

  @ViewChild(IonHeader, { read: ElementRef }) ionHeader: ElementRef<HTMLIonHeaderElement>;
  @ViewChild(IonContent, { read: ElementRef }) ionContent: ElementRef<HTMLIonContentElement>;
  @ViewChild(IonFooter, { read: ElementRef }) ionFooter: ElementRef<HTMLIonFooterElement>;
  @ViewChild('pane', { read: ElementRef }) pane: ElementRef<HTMLDivElement>;

  @ViewChild('swiper_today') swiper_today: SwiperComponent;
  @ViewChild('swiper_personal') swiper_personal: SwiperComponent;
  @ViewChild('swiper_knowhow') swiper_knowhow: SwiperComponent;
  
  @ViewChild('ringContainer') private ringContainer: ElementRef<HTMLDivElement>;

  @ViewChild('svg') svg: ElementRef<any>;
  @ViewChild('wedge') wedge: ElementRef<any>;
  
  private _loadingDialogs: boolean = false;

  public fromLogin = '';
  public firstname = '';
  public fromOnboarding = false;
  private _dialogs: Array<Dialog>;
  private _dialogGroups: DialogGroups;
  private _noOpenDialogsText: string = '';
  private _noOpenDialogsText2: string = '';
  private _lastReflectionTipTitle: string = null;
  private _lastReflectionTipText: string = '';

  private _daytime: Daytime = Daytime.Morning;
  private _lastReflectionAnswerDate: moment.Moment = null;
  public interactionCompleted: boolean = true;

  private _contentImg: string = null;
  private _userContent: UserContent = null;

  private _podcastButtonAges: Array<Date> = [];
  private _podcastLastViewedAt: moment.Moment = null;

  private paneLeft = 0;
  private paneLeftStart = 0;
  private paneVelocityX: number = 0;
  private lastMove: number = 0;

  public infoData: Array<any> = []; 
  public infoClass: Array<string> = [];

  public dotNr = 0;
  public oldDotNr = -1;

  // lower panel
  public lowerPanelMapping: Array<Array<any>> = [
    [],
    [],
    [],
    ['monitoring'],//['mindset', 'efficacy', 'performance'],
    ['themes', 'podcasts', 'videos', 'tips'],
  ];

  public lowerPanelPosition = 0;

  public monitoringData = [];
  public themesData = [];
  public podcastsData = [];
  public videosData = [];
  public tipsData = [];

  public thesesStat = [];
  public levelName: string = '';

  private noDialogsCnt = 0;

  private carouselTime = moment();

  private isOnCarouseling = false;

  private modMarginTop: string;
  private modMaxRingWidth: string;

  private recentNotification: ActionPerformed = null;

  public mode: string = '';
  private standardAnimated = false;

 constructor(
    private navService: NavService,
    private activatedRoute: ActivatedRoute,
    private platform: Platform,
    private dialogsService: DialogsService,
    private interactionService: InteractionService,
    private daytimeService: DaytimeService,
    private translateService: TranslateService,
    private userService: UserService,
    private fcmService: FCMService,
    private tipService: TipService,
    private badgeService: BadgeService,
    private contentService: ContentService,
    private gestureCtrl: GestureController, 
    private cdRef: ChangeDetectorRef,
    private animationCtrl: AnimationController,
    private alertCtrl: AlertController,
    private launchReview: LaunchReview,
    private localSettingsService: LocalSettingsService
  ) {
    this.mode = this.userService.getMode();
    if ( navService.get('fromLogin') !== undefined ) {
      this.fromLogin = 'fromLogin';
      this.dotNr = 1;
      this.oldDotNr = 1;
    }

    if ( navService.get('fromOnboarding') !== undefined ) {
      this.fromOnboarding = true;
    }

    if ( navService.get('name') !== undefined ) {
      this.firstname = navService.get('name');
    }

    if ( navService.get('modMarginTop') !== undefined ) {
      this.modMarginTop = navService.get('modMarginTop');
    }

    if ( navService.get('modMaxRingWidth') !== undefined ) {
      this.modMaxRingWidth = navService.get('modMaxRingWidth');
    }
        
    if ( this.fromLogin == '' && this.firstname == '' && this.dotNr == 0) {
      this.dotNr = 1;
      this.oldDotNr = 0;
      setTimeout(() => { this.tryAnimateWedge(10); });
    }

    this.initPushNotifications();
    platform.resume.subscribe(this.onResume.bind(this));

    if (platform.getQueryParam('go') === 'podcast') {
      this.showPodcastPage();
    }

    if ( this.firstname == '' ) { // e.g. after browser reload
      this.userService
        .getUserProfile('firstname')
        .subscribe((profile: UserProfile) => {
          this.firstname = profile.firstname;
          this.translateService
            .get('DIALOGS.NO_OPEN_DIALOGS', {name: this.firstname})
            .subscribe((text) => { this._noOpenDialogsText = text; });
        });
    }
    else {
      this.translateService
        .get('DIALOGS.NO_OPEN_DIALOGS', {name: this.firstname})
        .subscribe((text) => { this._noOpenDialogsText = text; });
    }
    this.translateService
      .get('DIALOGS.NO_OPEN_DIALOGS2')
      .subscribe((text) => { this._noOpenDialogsText2 = text; });
      console.log('~~~ '+((new Date()).getTime())+' Const Dash 9');
    }

  ngAfterViewInit() {
    const gesture = this.gestureCtrl.create({
      el: this.ionContent.nativeElement,
      onStart: () => this.onStart(),
      onMove: (detail) => this.onMove(detail),
      onEnd: () => this.onEnd(),
      gestureName: 'pane',
    });

    gesture.enable();
    this.noDialogsCnt = 0;
    // console.log('~~~ '+((new Date()).getTime())+' ngAfterViewInit 2');

    if ( this.fromLogin === 'fromLogin' && this.mode != 'simple' ) {
      setTimeout(() => {
        this.fromLogin = 'fromLogin loginAnimation';
        setTimeout(() => this.fromLogin = '', 4700);
        setTimeout(() => this.animateWedge(), 4600);
      }, 0);
      this.standardAnimated = true;
    }
  }

  private getDegDot(dotNr: number): number {
    return dotNr == 0 ? 180 : (135+dotNr*90);
  }

  ionViewWillEnter() {
    this.mode = this.userService.getMode();
    if (this.mode == '') { // after browser page reload i.e.
      this.localSettingsService.get(LocalSettingsService.MODE)
        .then((mode) => {
          if (mode == null) { // Querstart im Browser mit altem User
            mode = 'standard';
            this.localSettingsService.set(LocalSettingsService.MODE, mode);
          }
          this.mode = mode;
          this.userService.setMode(mode);
        })
    }
    if ( this.modMarginTop === undefined ) {
      this.onResize();
    }
    else {
      if ( this.ringContainer !== undefined && this.ringContainer.nativeElement !== undefined ) {
        this.ringContainer.nativeElement.style.marginTop = this.modMarginTop;
        if ( this.modMaxRingWidth !== undefined ) {
          this.ringContainer.nativeElement.style.maxWidth = this.modMaxRingWidth;
          this.ringContainer.nativeElement.style.maxHeight = this.modMaxRingWidth;
        }
      }
    }
  }

  onResize() {
    if ( this.ringContainer === undefined || this.ringContainer.nativeElement === undefined ||
      this.ionHeader === undefined || this.ionHeader.nativeElement === undefined || 
      this.ionHeader.nativeElement.offsetHeight == 0
    ) {
      setTimeout(() => { this.onResize(); }, 200);
    }
    else if ( this.ringContainer.nativeElement.style.marginTop != '40vh' ) {
      this.ringContainer.nativeElement.style.marginTop = '40vh';
      this.modMarginTop = undefined;
      setTimeout(() => { this.onResize(); }, 100);
    }
    else {
      const hh = this.ionHeader.nativeElement.offsetHeight;
      const hc = this.ionContent.nativeElement.offsetHeight;
      const hf = this.ionFooter.nativeElement.offsetHeight;
      const t = this.ringContainer.nativeElement.offsetTop;
      const hR = this.ringContainer.nativeElement.offsetHeight;
      let t1, t2;
      // besser zentrieren
      if ( (hh+hc+hf) / 2 - hh < t ) {
        t1 = (hh+hc+hf) / 2 - hh;
        console.log("mod ring position1 d " + hh + " " + hc + " " + hf + " " + hR + " " +  t + " => " + t1);
      }
      if ( t + hR / 2 + 40 > hc ) {
        t2 = Math.max(hc - hR / 2 - 40, 16);
        console.log("mod ring position2 d " + hh + " " + hc + " " + hf + " " + hR + " " +  t + " => " + t2);
      }
      let tNeu;
      if ( t1 !== undefined ) {
        tNeu = t1;
      }
      if ( t2 !== undefined ) {
        tNeu = (t1 !== undefined ? Math.min(t1, t2) : t2);
      }
      if ( tNeu != undefined ) {
        this.ringContainer.nativeElement.style.marginTop = tNeu+'px';
        this.modMarginTop = tNeu+'px';
      }
      if ( hR + 40 > hc ) {
        this.modMaxRingWidth = (hR-40)+'px';
        this.ringContainer.nativeElement.style.maxWidth = this.modMaxRingWidth;
        this.ringContainer.nativeElement.style.maxHeight = this.modMaxRingWidth;
      }
    }
  }

  ngAfterContentChecked() {
    if (this.swiper_today) {
      this.swiper_today.updateSwiper({});
    }
    if (this.swiper_personal) {
      this.swiper_personal.updateSwiper({});
    }
    if (this.swiper_knowhow) {
      this.swiper_knowhow.updateSwiper({});
    }
  }

  private onStart() {
    if ( this.dotNr != 1) {
      return false;
    }
    this.setCarousel(20);
    this.cdRef.detectChanges();
    this.paneLeftStart = this.paneLeft;
    this.pane.nativeElement.style.setProperty('transition', '');
  }

  private onMove(detail: GestureDetail) {
    if ( this.dotNr != 1) {
      return false;
    }
    const { type, currentX, deltaX, velocityX } = detail;
    // this.pane.nativeElement.innerHTML = `
    //   <div>Type: ${type}</div>
    //   <div>Current X: ${currentX}</div>
    //   <div>Delta X: ${deltaX}</div>
    //   <div>Velocity X: ${velocityX}</div>`;
    this.paneLeft = this.paneLeftStart + deltaX;
    this.paneVelocityX = velocityX;
    this.pane.nativeElement.style.setProperty('left', this.paneLeft + 'px');
  }

  private onEnd() {
    if ( this.dotNr != 1) {
      return false;
    }
    this.cdRef.detectChanges();
    this.pane.nativeElement.style.setProperty('transition', 'left 1s cubic-bezier(.26,.68,.83,1.16)');
    const infoWidth = this.pane.nativeElement.clientWidth / 10;
    let pos = this.paneLeft / infoWidth;
    // console.log("vel: " + this.paneVelocityX);
    // console.log("pos: " + pos);
    let index;    
    if ( this.paneVelocityX < 0 ) {
      index = Math.floor(pos);
    }
    else {
      index = Math.ceil(pos);
    }
    if (index > 0) {
      index = 0;
    }
    if (index <= - this.infoData.length) {
      index = -this.infoData.length+1;
    }
    this.paneLeft = index*infoWidth;
    // console.log("left: " + this.paneLeft + " " + infoWidth + " : " + index + "(" + this.infoData.length+")");
    this.pane.nativeElement.style.setProperty('left', this.paneLeft + 'px');
    this.lastMove = (new Date()).getTime();
    this.setCarousel(20);
    this.checkMoveContent(this.infoData[-index]);
  }

  private validateInfoPosition(): void {
    const infoWidth = this.pane.nativeElement.clientWidth / 10;
    let pos = this.paneLeft / infoWidth;
    let index = Math.floor(pos);
    if (index <= - this.infoData.length) {
      index = -this.infoData.length+1;
      this.paneLeft = index*infoWidth;
      console.log("left: " + this.paneLeft + " " + infoWidth + " : " + index + "(" + this.infoData.length+")");
      this.pane.nativeElement.style.setProperty('transition', '');
      this.pane.nativeElement.style.setProperty('left', this.paneLeft + 'px');
      this.lastMove = (new Date()).getTime();
    }
  } 

  public set dialogs(value: Array<Dialog>) {
    // aufbereiten für Info
    console.log("### set dialogs #" + value.length + ", RecentNotification: " + JSON.stringify(this.recentNotification));
    let i = 0;
    let recentDialogIds: Set<string> = new Set<string>();
    if ( this.recentNotification != null 
        && this.recentNotification.notification.data !== undefined
        && this.recentNotification.notification.data.dialogIds !== undefined
        && this.recentNotification.notification.data.dialogIds !== '') {
      // console.log("### RecentNotification: A");
      const dialogIds = JSON.parse(this.recentNotification.notification.data.dialogIds);
      // console.log("### RecentNotification: B %o", dialogIds);
      // console.log("### RecentNotification: C %o", dialogIds[0]);
      dialogIds.forEach(diaId => {
        if (recentDialogIds.has(diaId)) {
          return;
        }
        const dialog = value.find((dia) => dia._id+'' == diaId + '' || 
          (dia.goalId !== undefined && 'goal_' + dia.goalId == diaId));
        // console.log("### RecentNotification: D "+JSON.stringify(dialog));
        if (dialog !== undefined) {
          // console.log("### RecentNotification: E " + this.getDialogTitle(dialog));
          this.infoData[i++] = {title: this.getDialogTitle(dialog), dialog: dialog};
          recentDialogIds.add(diaId);
        }
      });
    }
    // Klären was das hier macht/machen sollte
    // else if ( this.infoData[0] != undefined && this.infoData[0].subtext !== undefined && this.infoData[0].consumed === undefined) {
    //   this.infoData[i++].consumed = true;
    // }
    
    if (value != undefined && value != null && value.length > 0) {
      const groups: DialogGroups = value.reduce(DashboardPage.groupDialogsByDate, {});

      Object.keys(groups).forEach((key) => {
        groups[key].sort(DashboardPage.sortDialogsByDate);
      });
      this._dialogGroups = groups;

      Object.keys(this._dialogGroups).sort((a, b) => {
        return moment(b, INDEX_FORMAT).diff(moment(a, INDEX_FORMAT));
      }).forEach(key => {
        if (i < 10) {
          for (let j = 0; j < this._dialogGroups[key].length; j++) {
            if (i < 10) {
              const dialog = this._dialogGroups[key][j];
              if (!recentDialogIds.has(dialog.goalId !== undefined ? 'goal_' + dialog.goalId : dialog._id)) {
                this.infoData[i++] = {title: this.getDialogTitle(dialog), dialog: dialog};
              }
            }
          }
        }
      });
    }
    else {
      this._dialogGroups = {};
    }
    console.log("### A "+ this.infoData.length);
    this.infoData.length = i;
    this.checkInfoDateNotEmpty();

    if ( this.mode == 'standard' ) {
      this.validateInfoPosition();
    }

    this._dialogs = value;
    if ( this.mode == 'standard' ) {
      this.setCarousel(7);
    }
    
    // reset recentNotification
    this.recentNotification = null;
  }

  private checkInfoDateNotEmpty() {
    if ( this.infoData.length == 0 ) {
      this.infoData[0] = {text: this._noOpenDialogsText, subtext: " "};
    }
  }

  private setCarousel(seconds: number) {
    this.carouselTime = moment().add(seconds, 'second');
    setTimeout(() => this.doCarousel(), seconds*1000 + 20);
  }

  private doCarousel() {
    if ( moment().isAfter(this.carouselTime) ) {
      this.pane.nativeElement.style.setProperty('transition', 'left 1s cubic-bezier(.26,.68,.83,1.16)');
      const infoWidth = this.pane.nativeElement.clientWidth / 10;
      let pos = this.paneLeft / infoWidth;
      // console.log("vel: " + this.paneVelocityX);
      // console.log("pos: " + pos);
      let index = Math.floor(pos)-1;
      if (index > 0) {
        index = 0;
      }
      if (index <= - this.infoData.length) {
        index = 0;
      }
      this.paneLeft = index*infoWidth;
      this.pane.nativeElement.style.setProperty('left', this.paneLeft + 'px');

      this.setCarousel(7);
      this.isOnCarouseling = true;
      this.checkMoveContent(this.infoData[-index]);
      setTimeout(() => { this.isOnCarouseling = false; }, 1000);
    }
  }

  public moveCarousel(dir: number): void {
    this.setCarousel(20);
    this.pane.nativeElement.style.setProperty('transition', 'left 1s cubic-bezier(.26,.68,.83,1.16)');
    const infoWidth = this.pane.nativeElement.clientWidth / 10;
    let pos = this.paneLeft / infoWidth;
    // console.log("vel: " + this.paneVelocityX);
    // console.log("pos: " + pos);
    let index = Math.floor(pos)-dir;
    if (index > 0) {
      index = 0;
    }
    if (index <= - this.infoData.length) {
      index = - this.infoData.length+1;
    }
    this.paneLeft = index*infoWidth;
    this.pane.nativeElement.style.setProperty('left', this.paneLeft + 'px');
    this.isOnCarouseling = true;
    this.checkMoveContent(this.infoData[-index]);
    setTimeout(() => { this.isOnCarouseling = false; }, 1000);
  }

  public jumpCarousel(ind: number): void {
    this.setCarousel(20);
    this.pane.nativeElement.style.setProperty('transition', 'left 1s cubic-bezier(.26,.68,.83,1.16)');
    const infoWidth = this.pane.nativeElement.clientWidth / 10;
    let pos = this.paneLeft / infoWidth;
    // console.log("vel: " + this.paneVelocityX);
    // console.log("pos: " + pos);
    let index = -ind;
    if (index > 0) {
      index = 0;
    }
    if (index <= - this.infoData.length) {
      index = - this.infoData.length+1;
    }
    this.paneLeft = index*infoWidth;
    this.pane.nativeElement.style.setProperty('left', this.paneLeft + 'px');
    // keien checkMoveContent
  }

  public get hasDialogs(): boolean {
    return !this.loadingDialogs && this._dialogs && this._dialogs.length > 0;
  }

  public static groupDialogsByDate(groups: Dictionary<Array<Dialog>>, item: Dialog): Dictionary<Array<Dialog>> {
    const index: string = moment(item.lastStart).format(INDEX_FORMAT);
    if (item.lastStart !== undefined) {
      item.sortTime = moment.utc(item.lastStart).add(-moment().utcOffset(), 'minutes').format('HH:mm')
        +' ls'
        +(item.contentInfo !== undefined ? ' k' : '');
    }
    else if (item.fullGoal != undefined) {
      item.sortTime = item.fullGoal.time+ ' gl'; 
    }
    else if (item.startDate != undefined) {
      item.sortTime = moment.utc(item.startDate).add(-moment().utcOffset(), 'minutes').format('HH:mm')+' st';
    }
    else {
      item.sortTime = '..:..'; // theses first
    }
    if (index in groups) {
      groups[index].push(item);
    } else {
      groups[index] = [item];
    }
    return groups;
  }

  public static sortDialogsByDate(dialogA: Dialog, dialogB: Dialog): number {
    /*const aDate: moment.Moment = moment.utc(dialogA.lastStart);
    const bDate: moment.Moment = moment.utc(dialogB.lastStart);

    return bDate.diff(aDate);*/
    if (dialogB.sortTime == dialogA.sortTime) {
      if (dialogA.contentInfo !== undefined && dialogB.contentInfo !== undefined) {
        if (dialogA.contentInfo.title._id == dialogB.contentInfo.title._id) {
          return dialogB.contentInfo.pos < dialogA.contentInfo.pos ? 1 : -1;
        }
      }
    }
    return dialogB.sortTime < dialogA.sortTime ? 1 : -1; 
  }

  public get newestDialog(): Dialog {
    if (this._dialogGroups === undefined || Object.keys(this._dialogGroups).length <= 0) {
      return null;
    }

    const firstIndex: string = Object.keys(this._dialogGroups).sort((a, b) => {
      return moment(b, INDEX_FORMAT).diff(moment(a, INDEX_FORMAT));
    })[0];

    return this._dialogGroups[firstIndex][0];
  }

  public get newestDialogTitle(): string {
    if (this.newestDialog) {
      if (this.newestDialog.fullGoal !== undefined && this.newestDialog.fullGoal.dialog === undefined) {
        return this.newestDialog.fullGoal.title;
      }

      return getTranslation(this.newestDialog.title, this.translateService);
    }

    return this._noOpenDialogsText;
  }

  private checkMoveContent(data: any): void {
    if ( data != undefined && data.dialog !== undefined && data.dialog.contentInfo !== undefined ) {
      const uc_id = data.dialog.contentInfo.uc_id;
      for (let i = 0; i < this.lowerPanelMapping[1].length; i++) {
        if ( this.lowerPanelMapping[1][i]._id == uc_id ) {
          console.log("SWIPE TO %o", this.lowerPanelMapping[1][i].contentFull.title.de);
          // move to i
          this.swiper_today?.swiperRef?.slideTo(i+1, 1000);
        }
      }
    }
  }

  public checkMoveDialog(e: any): void {
    if ( this.isOnCarouseling ) {
      this.isOnCarouseling = false;
      return;
    }
    this.setCarousel(20);
    const uc_id = this.lowerPanelMapping[1][e[0].realIndex]._id;
    for (let i = 0; i < this.infoData.length; i++) {
      if ( this.infoData[i].dialog !== undefined && this.infoData[i].dialog.contentInfo !== undefined && 
        this.infoData[i].dialog.contentInfo.uc_id == uc_id ) {
        this.jumpCarousel(i);
        return;  
      }
    }
    this.setCarousel(7);
  }

  public get daytime(): Daytime {
    return this._daytime;
  }

  public get loadingDialogs(): boolean {
    return this._loadingDialogs;
  }

  public getDialogTitle(dialog: Dialog): string {
      if (dialog.fullGoal !== undefined && dialog.fullGoal.dialog === undefined) {
        return dialog.fullGoal.title;
      }

      return getTranslation(dialog.title, this.translateService);
  }


  public get newBadgeCount(): number {
    return this.userService.getNewBadgeCount();
  }

  public get newContentCount(): number {
    return this.userService.getNewContentCount();
  }

  public get hasContent(): boolean {
    return this._userContent !== null;
  }

  public get contentImg(): string {
    return this._contentImg;
  }

  public get contentTitle(): string {
    return getTranslation(this._userContent.contentFull.title, this.translateService);
  }

  public get isContentRunning(): boolean {
    return this._userContent.state >= 5;
  }

  public get isContentSuggest(): boolean {
    return this._userContent.suggest !== undefined && this._userContent.suggest > 0;
  }

  public get newPodcastCount(): number {
    if (this._podcastLastViewedAt !== null) {
      return this._podcastButtonAges.filter((age) => moment(age).isAfter(this._podcastLastViewedAt)).length;
    }
    return 0;
  }

/*  public get theme(): string {
    if( this.userService.getTheme() == '' ) {

    }
   return this.userService.getTheme(); 
  }*/

  public ngOnInit(): void {
    this.activatedRoute.data.subscribe((data) => {
          if ( data.podcast ) {
            this.showPodcastPage();
          }
      });
      console.log("FillFirstName");
      this.userService
      .getUserProfile('firstname')
      .subscribe((profile: UserProfile) => {
        this.firstname = profile.firstname;
        if ( this.infoData[0] != undefined && this.infoData[0].subtext !== undefined ) {
          this.translateService.get('LOGIN.HELLO_WITH_NAME', {name: this.firstname})
            .subscribe((translation) => {
            this.infoData[0].text = translation;
            });
        }
      });
  }

  private ionViewDidEnter(): void {
    this.refresh();
    if ( !this.standardAnimated && this.mode != 'simple' ) {
      // happens wenn App started as simnple and then switched to standard
      // so we need to display the animated stuff immediately
      setTimeout(() => {
        this.fromLogin = 'fromLogin loginImmediately';
      }, 0);
    }
  }

  private refresh(): void {
    this.checkInteractionStatus();
    // this.loadDialogs(); // passiert schon im checkInteractionStatus
    this.loadContents();
    this.loadPodcastButtonAges();
    this.loadLowerPanelData();
    this.noDialogsCnt = 0;
  }

  private checkInteractionStatus(): void {
    this.interactionCompleted = true;
    let currentQuestionTime;

    this.daytimeService.getCurrentQuestionTime()
      .pipe(mergeMap((questionTime) => {
        currentQuestionTime = questionTime;
        this._daytime = currentQuestionTime.daytime;
        return this.interactionService.getInteractionStatus();
      }))
      .subscribe((status) => {

        this._lastReflectionAnswerDate = moment(status.expectedDateOfLastAnswer);
        if ( status.newBadges !== undefined ) {
          this.userService.setNewBadgeCount(status.newBadges);
        }

        this.badgeService.calculateNewBadges()
          .subscribe((cnt) => {
            if (cnt > 0) {
              this.userService.setNewBadgeCount(this.userService.getNewBadgeCount() + cnt);
            }
          });

        this.contentService.calculateNewContents()
          .subscribe((cnt) => {
            this.userService.setNewContentCount(cnt);
            // an autostart could have been activated, so better reload, but without disturbing the UI
            this.dialogsService.getDialogs(this.userService.getDevEpisodes() != '' ? '?episodes=' + this.userService.getDevEpisodes() : '')
              .subscribe((dialogs) => { 
                this.dialogs = dialogs;
              if (this.fromOnboarding) { // may be open Ally-Content?
                this.loadContents();
              }
            });
          });
        // console.log('from server ', status.expectedDateOfLastAnswer);
        // console.log('conv ', this._lastReflectionAnswerDate.format());

        if (status.lastReflectionTip) {
          this._lastReflectionTipText = getTranslation(status.lastReflectionTip['text'], this.translateService);
          const isToday: boolean = (moment(status.lastReflectionTip.date).format(INDEX_FORMAT) == moment().format(INDEX_FORMAT));
          this.userService
            .getUserProfile('firstname')
            .subscribe((profile: UserProfile) => {
              this.firstname = profile.firstname
              this.translateService
                .get(isToday ? 'REFLECTION.PLAN.TODAY' : 'REFLECTION.PLAN.OLDER',
                  {datum: moment(status.lastReflectionTip.date).format('DD.MM.YYYY'), name: profile.firstname})
                .subscribe((text) => {
                  this._lastReflectionTipTitle = text;
                });
              });
        }

        switch (this._daytime) {
          case Daytime.Morning:
          case Daytime.Midday: this.interactionCompleted = status.morning; break;
          case Daytime.Evening: this.interactionCompleted = status.evening; break;
          case Daytime.Resilience: this.interactionCompleted = status.resilience; break;
          case Daytime.Night: // careful: could be we are in the early morning before morning reflection time
            if (moment().startOf('day').isAfter(moment(currentQuestionTime.date))) {
              this.interactionCompleted = true;
            } else {
              this.interactionCompleted = status.night;
            }
            break;
          default: this.interactionCompleted = true; break;
        }

        if (status.requestReview !== undefined && this.platform.is('capacitor')) {
          setTimeout(() => this.openLaunchReview(), 2000)
        }
      });
  }

  public get lastReflectionTipTitle(): string {
    return this._lastReflectionTipTitle;
  }

  public get lastReflectionTipText(): string {
    return this._lastReflectionTipText;
  }

  private loadDialogs(): void {
    this._loadingDialogs = true;

    this.dialogsService.getDialogs()
      .pipe(finalize(() => { this._loadingDialogs = false; }))
      .subscribe((dialogs) => { this.dialogs = dialogs; });
  }

  private loadPodcastButtonAges(): void {
    this.tipService.getPodcastButtonAges('podcast')
      .subscribe((ages) => { this._podcastButtonAges = ages; });
  }

  private initPushNotifications(): void {
    this.fcmService.setNotificationCallback(this.onFCMNotification.bind(this));
    this.fcmService.setTokenRefreshCallback(this.onFCMTokenSuccess.bind(this));

    this.userService.setTimeInfo(
      moment().utcOffset(),
      navigator.language ? navigator.language : '',
    ).subscribe();

    this.fcmService.getDeviceToken()
      .subscribe(this.onFCMTokenSuccess.bind(this));

//    console.log("### A");
    if ( this.fcmService.recentlyActionPerformed(true) ) {
      this.recentNotification = this.fcmService.getStoredNotification(true);
    }
  }

  private loadContents(): void {
    this.lowerPanelMapping[1] = [];
    this.userService.getUserProfile('contents')
    .subscribe((profile: UserProfile) => {
      if (profile.podcastLastViewedAt) {
        this._podcastLastViewedAt = moment(profile.podcastLastViewedAt);
      }
    });
    this.contentService.getContents('dashboard')
    .subscribe((contents: Array<UserContent>) => {
      if ( contents !== null && contents !== undefined && contents.length > 0) {
        // try running contents
        let cands: Array<UserContent> = contents.filter((userContent) => userContent.state === 5);
        // if nothing there try startables
        if (cands === undefined || cands.length === 0) {
          cands = contents.filter((userContent) => userContent.state === 0);
        }
        // if nothing there try purchaseables
        if (cands === undefined || cands.length === 0) {
          cands = contents.filter((userContent) => userContent.state === 3);
        }
        if (cands.length > 10) {
          cands.length = 10; // forceably cut down, else the layout is battered // TODO may remove the recentNotifiation ones
        }
        const keepCands = [...cands];
        setTimeout(() => { this.lowerPanelMapping[1] = keepCands; },100);
        console.log("cont  %o", keepCands);
        let cand: UserContent;
        if (cands !== undefined && cands.length > 0) {
          let candsSuggest = cands.filter((userContent) => userContent.suggest !== undefined && userContent.suggest > 0);
          if (candsSuggest !== undefined && candsSuggest.length > 0) {
            cands = candsSuggest;
          }
          cand = cands[Math.floor(Math.random() * cands.length)];
        }
        if (cand !== undefined) {
          this._userContent = cand;
          if (cand.suggest !== undefined) {
            this._userContent.suggest = cand.suggest;
          }
          // let s: string =  getTranslation(cand.contentFull.description, this.translateService);
          // s = s.replace('http://www.synk-group.com', 'https://www.synk-group.com');
          // if ( s.search(/\!\[[^\]]*\]\(([^\)]+)\)/) !== -1 ) {
          //   this._contentImg = RegExp.$1;
          // }
        }
        // lower panel
        const themesData: Array<any> = [
          [this.translateService.instant('LP.ALL'), 0, 0], 
          [this.translateService.instant('LP.STARTED'), 0, 0],
          [this.translateService.instant('LP.DONE'), 0, 0],
        ];
        contents.forEach(userContent => {
          themesData[0][1]++;
          if ( userContent.state >= 5 ) {
            themesData[1][1]++;
          }
          if ( userContent.state >= 8 ) {
            themesData[2][1]++;
          }
        });
        if ( themesData[0][1] > 0 ) {
            themesData[0][2] = 100;
            themesData[1][2] = (100 * themesData[1][1] / themesData[0][1]).toFixed(1);
            themesData[2][2] = (100 * themesData[2][1] / themesData[0][1]).toFixed(1);
        }
        this.themesData = themesData;

        if ( this.fromOnboarding ) {
          this.fromOnboarding = false;
          console.log("### FROM ONBOARDING "+this.userService.getCompanyCached());
          if ( this.userService.getCompanyCached() == 'SYNK_ALLY_Leadership_Summit' ) {
            const allyStartContent = contents.find(cont => cont.contentFull !== undefined 
              && cont.contentFull.title !== undefined
              && cont.contentFull.title.de !== undefined
              && cont.contentFull.title.de == 'Ally Leadership Summit (hier starten)');
            if (allyStartContent !== undefined)  {
              //this.navService.push('content/flow', {userContent: allyStartContent});
              this.showContent(allyStartContent);
            }
          }
        }
      }
    });
  }

  private loadLowerPanelData() {
    this.tipService.getByType(VIDEO_TYPE)
      	.subscribe((videos) => {
          const videosData: Array<any> = [
            [this.translateService.instant('LP.ALL'), 0, 0], 
            [this.translateService.instant('LP.STARTED'), 0, 0],
            [this.translateService.instant('LP.DONE'), 0, 0],
          ];
          videos.forEach(tiplist => {
            tiplist.tips.forEach((tip) => {
              videosData[0][1]++;
              if (tip.rating) {
                videosData[1][1]++;
                if (tip.rating >= 0 ) {
                  videosData[2][1]++;
                }
              }
            });
          });
          if ( videosData[0][1] > 0 ) {
            videosData[0][2] = 100;
            videosData[1][2] = (100 * videosData[1][1] / videosData[0][1]).toFixed(1);
            videosData[2][2] = (100 * videosData[2][1] / videosData[0][1]).toFixed(1);
          }
          this.videosData = videosData;
        });

    this.tipService.getByType(PODCAST_TYPE)
    .subscribe((podcasts) => {
      const podcastsData: Array<any> = [
        [this.translateService.instant('LP.ALL'), 0, 0], 
        [this.translateService.instant('LP.STARTED'), 0, 0],
        [this.translateService.instant('LP.DONE'), 0, 0],
      ];
      podcasts.forEach(tiplist => {
        tiplist.tips.forEach((tip) => {
          podcastsData[0][1]++;
          if (tip.rating) {
            podcastsData[1][1]++;
            if (tip.rating >= 0 ) {
              podcastsData[2][1]++;
            }
          }
        });
      });
      if ( podcastsData[0][1] > 0 ) {
        podcastsData[0][2] = 100;
        podcastsData[1][2] = (100 * podcastsData[1][1] / podcastsData[0][1]).toFixed(1);
        podcastsData[2][2] = (100 * podcastsData[2][1] / podcastsData[0][1]).toFixed(1);
      }
      this.podcastsData = podcastsData;
    });

    this.tipService.getByType(TIP_TYPE)
    .subscribe((tips) => {
      const tipsData: Array<any> = [
        [this.translateService.instant('LP.ALL'), tips[0], 0], 
        [this.translateService.instant('LP.STARTED'), tips[1], 0],
        [this.translateService.instant('LP.DONE'), tips[2], 0],
      ];
      if ( tipsData[0][1] > 0 ) {
        tipsData[0][2] = 100;
        tipsData[1][2] = (100 * tipsData[1][1] / tipsData[0][1]).toFixed(1);
        tipsData[2][2] = (100 * tipsData[2][1] / tipsData[0][1]).toFixed(1);
      }
      this.tipsData = tipsData;
    }); 

    // Monitoring
/*    this.dialogsService.getThesesStats('', new Date(), 'd', 'u')
    .subscribe((stats: Array<ThesesStats>) => {
      const monitoringData = [
        [this.translateService.instant('THESES.MINDSET'), -1, 0], 
        [this.translateService.instant('THESES.EFFICACY'), -1, 0],
        [this.translateService.instant('THESES.PERFORMANCE'), -1, 0],
      ];
      stats.filter(stat => stat.name == 'mindset').forEach(stat => {
        const v = this.thesisStatsToPercent(stat.val);
        monitoringData[0][1] = v+'%';
        monitoringData[0][2] = v;
      });
      stats.filter(stat => stat.name == 'efficacy').forEach(stat => {
        const v = this.thesisStatsToPercent(stat.val);
        monitoringData[1][1] = v+'%';
        monitoringData[1][2] = v;
      });
      stats.filter(stat => stat.name == 'performance').forEach(stat => {
        const v = this.thesisStatsToPercent(stat.val);
        monitoringData[2][1] = v+'%';
        monitoringData[2][2] = v;
      });
      this.monitoringData = monitoringData;
    });*/
    this.dialogsService.getDialogsStats()
    .subscribe((stats: DialogStats) => {
      console.log(stats);
      const monitoringData = [
        [this.translateService.instant('MONITORING.DIALOGS'), stats.cntDiaUser, this.lvlRel(stats.cntDiaUser, stats.cntDiaGroup, stats.cntGroup)], 
        [this.translateService.instant('MONITORING.CONTENTS'), stats.cntContUser, this.lvlRel(stats.cntContUser, stats.cntContGroup, stats.cntGroup)],
        [this.translateService.instant('MONITORING.LEVEL.NAME'), this.translateService.instant('MONITORING.LEVEL.LONG.'+stats.level), stats.level*50],
      ];
      this.monitoringData = monitoringData;
      this.levelName = this.translateService.instant('MONITORING.LEVEL.SHORT.'+stats.level);
    });
  }

  private lvlRel(cntUser: number, cntGroup: number, nGroup: number): any {
    if (cntGroup == 0 || nGroup == 0) {
      return 0;
    }
    const valGroup = cntGroup / nGroup * 1.2;
    return cntUser > valGroup ? 100 : (100 * cntUser / valGroup).toFixed(1);
  }

  private thesisStatsToPercent(a: number) {
    // between 1 and 5, scate to 0 - 100%
    return ((a-1)*25).toFixed(0);
  }

  private getLastStart(dialog: Dialog): string {
    const startDate: moment.Moment = moment.utc(dialog.startDate);
    const matchDate: moment.Moment = moment();

    while (startDate.isSameOrBefore(matchDate)) {
      startDate.add(dialog.intervalValue, dialog.intervalUnit);
    }

    return startDate.subtract(dialog.intervalValue, dialog.intervalUnit).toISOString();
  }

  public showContentPage(): void {
    this.navService.push('content', {selUserContent: this._userContent});
  }

  public showHistoryPage(): void {
    this.navService.push('history');
  }

  public showTipsPage(): void {
    this.translateService.get('TIPS.TITLE').subscribe((title) => {
      this.tipService.getRootQuestion().subscribe((question) => {
        this.navService.push('tips/' + question._id, {
          question: question,
          overrideTitle: title,
          isInReflectionMode: false,
        });
      });
    });
  }

  public showInsightsPage(): void {
    this.navService.push('insights');
  }

  public showGoalPage(): void {
    this.navService.push('goals');
  }

  public showPodcastPage(): void {
    this.navService.push('knowledge/podcast');
  }

  public showInteractionPage(): void {
    let title: string;
    let questionTime: QuestionTime;
    let currentQuestionTime: QuestionTime;

    this.daytimeService.getQuestionTimeByLastAnswerDate(this._lastReflectionAnswerDate.toDate())
      .pipe(mergeMap((nextQuestionTime) => {
        if (nextQuestionTime == null) {
          // may happen if no reflection demanded
          return EMPTY;
        }
        questionTime = nextQuestionTime;
        return this.daytimeService.getCurrentQuestionTime();
      }))
      .pipe(mergeMap((theCurrentQuestionTime) => {
        currentQuestionTime = theCurrentQuestionTime;
        switch (questionTime.daytime) {
          case Daytime.Morning:
          case Daytime.Midday: title = 'REFLECTION.MORNING'; return this.tipService.getMorningInteration();
          case Daytime.Evening: title = 'REFLECTION.EVENING'; return this.tipService.getEveningInteration();
          case Daytime.Resilience: title = 'REFLECTION.RESILIENCE'; return this.tipService.getResilienceInteration();
          case Daytime.Night: title = 'REFLECTION.NIGHT'; return this.tipService.getNightInteration();
          default: title = 'REFLECTION.MORNING'; return this.tipService.getMorningInteration();
        }
      })).subscribe((question) => {
        this.translateService.get(title).subscribe((translatedTitle) => {
          this.navService.push('tips/' + question._id, {
            question: question,
            overrideTitle: translatedTitle,
            questionTime: questionTime,
            currentQuestionTime: currentQuestionTime,
            isInReflectionMode: true,
          });
        });
      });
  }

  public showNewestDialog(): void {
    if (!this.newestDialog) {
      return;
    }

    this.navService.push('dialogs/detail', { dialog: this.newestDialog });
  }

  public showDialog(dialog: Dialog): void {
    if ( (new Date()).getTime() - this.lastMove > 300 ) {
      if (dialog.ep !== undefined) {
        this.navService.push('goals/episodes', { dialogs: this._dialogs.filter(dia => dia.ep != undefined && dia.ep == dialog.ep) });
      }
      else if (dialog.contentInfo !== undefined) {
        this.navService.push('content/flow', { dialog: dialog });
      }
      else {
        this.navService.push('dialogs/detail', { dialog: dialog });
      }
    }
    else {
      console.log("prevent move click")
    }
  }

  public showDialogList(): void {
    if (!this.hasDialogs) {
      return;
    }

    this.navService.push('dialogs/list', { dialogs: this._dialogGroups });
  }

  public doneThesis(data: any, nr: number): void {
    this.dialogsService.postThesisAnswer(data.thesis, data.text, data.value).subscribe((res) => {
        this.infoClass[nr] = 'done';
        setTimeout(() => {
          console.log(this.infoData);
          let i = nr;
          while (i < this.infoData.length-1) {
            this.infoData[i] = this.infoData[i+1];
            i++;
          }
          this.infoData.length = i;
          this.infoClass[nr] = '';
          this.checkInfoDateNotEmpty();
          this.validateInfoPosition();
        }, 1000);
    });
  }

  public onTextClicked(): void {
    if ( this.noDialogsCnt == 0 ) {
      this.infoData[0] = {text: this._noOpenDialogsText2, subtext: " "};
      this.noDialogsCnt = 1;
    }
  }

  public showProfile(): void {
    this.navService.push('profile');
  }

  public showMenu(): void {
    this.navService.push('menu');
  }

  public showContent(userContent: UserContent) {
    console.log("showContent");
    if (userContent.state >= 5) {
      if ( userContent.state == 9) {
        this.navService.push('content/flow', { userContent: userContent });
        return;
      }
      // load matching Dialog
      const cand: Array<Dialog> = [];
      for(let i = 0; i < this._dialogs.length; i++) {
        if ( this._dialogs[i].contentInfo !== undefined && this._dialogs[i].contentInfo.uc_id == userContent._id ) {
          cand.push(this._dialogs[i]);
        }
      }
      if ( cand.length > 0 ) {
        const dia = cand.reduce((acc: Dialog, cur:Dialog) => acc == null || acc.contentInfo.pos > cur.contentInfo.pos ? cur : acc, null);
        this.navService.push('content/flow', { dialog: dia });
      } else {
        // otherwise no active dialog, so just display
        this.navService.push('content/flow', { userContent: userContent });
      }
    }
    else { // available or suggested
      this.navService.push('content', {selUserContent: userContent});
    }
  }

  // dot action 

  public getDotButtonClass(nr: number):string {
    return 'dot-button'+(this.dotNr == nr ? ' on' : (this.oldDotNr == nr ? ' off' : ''));
  }

  public onDot(dotNr: number) {
    console.log('~~~ '+((new Date()).getTime())+' onDot '+dotNr);
    if (dotNr == this.dotNr) {
      return;
    }
    this.pane.nativeElement.style.setProperty('transition', 'transform '+(this.dotNr == 0 ? '1' : '0.5')+'s ease-in-out'); // reset from panning
    this.oldDotNr = this.dotNr;
    this.dotNr = dotNr;
    setTimeout(() => { this.oldDotNr = -1; }, 1000);
    setTimeout(() => { this.ngAfterContentChecked(); }, 20); // swiper?
    const mv = this.oldDotNr+'_'+dotNr;
    // setTimeout(() => {
    console.log("MOVE "+mv);
    setTimeout(() => { this.animateWedge(); });
  }

  private animateWedge() {
    this.animationCtrl
          .create()
          .addElement(this.svg.nativeElement)
          .duration(500)
          .easing('ease-in-out')
          .fill('forwards')
          .fromTo('transform', 'rotate('+this.getDegDot(this.oldDotNr)+'deg)', 'rotate('+this.getDegDot(this.dotNr)+'deg)')
          //.to('transform', 'rotate('+this.getDegDot(dotNr)+'deg)')
          .play();
    this.animationCtrl
          .create()
          .addElement(this.wedge.nativeElement)
          .duration(500)
          .easing('ease-in-out')
          .fill('forwards')
          .fromTo('transform', 'rotate('+this.getDegDot(this.oldDotNr)+'deg)', 'rotate('+this.getDegDot(this.dotNr)+'deg)')
         // .to('transform', 'rotate('+this.getDegDot(dotNr)+'deg)')
          .play();
    // });
  }

  private tryAnimateWedge(trials: number) {
    if ( trials < 0 ) {
      return;
    }
    else if ( this.svg !== undefined && this.svg.nativeElement !== undefined ) {
      this.animateWedge();
    }
    else {
      setTimeout(() => { this.tryAnimateWedge(trials-1); }, 100);
    }
  }

  public showLowerPanel(name: string): boolean {
    if (name == 'today' && this.dotNr == 1) {
      return true;
    }
    return this.lowerPanelMapping[this.dotNr].includes(name) ||
     (this.oldDotNr != -1 && this.lowerPanelMapping[this.oldDotNr].includes(name));
  }

  public get ringSvgClass(): string {
    return 'dot'+this.dotNr;
  }
  
  public showPage(page: string): void {
    this.navService.push(page);
  }

  // FCM

  private onResume(): void {
    this.userService.setTimeInfo(
      moment().utcOffset(),
      navigator.language ? navigator.language : '',
    ).subscribe();
    this.fcmService.getDeviceToken().subscribe(this.onFCMTokenSuccess.bind(this));

    this.refresh();
  }

  private onFCMTokenSuccess(token: string): void {
    if (token !== '') {
      let deviceType: string = 'desktop';
      let appVersion: string = 'SERVE';
      if (this.platform.is('capacitor')) {
        if (this.platform.is('android')) {
          deviceType = 'android';
        } else if (this.platform.is('ios')) {
          deviceType = 'ios';
        } else {
          deviceType = 'capacitor';
        }

        App.getInfo().then((appInfo) => {
          appVersion = appInfo.version;
          this.userService.setDeviceInfo(token, deviceType, null, appVersion).subscribe();
        });
      } else {
        this.userService.setDeviceInfo(token, deviceType, null, appVersion).subscribe();
      }
    }
  }

  private onFCMNotification(notification: PushNotificationSchema): void {
    this.refresh();
  }

  private openLaunchReview(): void {
    this.translateService.get([
      'REVIEW_ALERT.TITLE',
      'REVIEW_ALERT.MESSAGE',
      'REVIEW_ALERT.BUTTON_LATER',
      'REVIEW_ALERT.BUTTON_GO',
    ]).subscribe(async(translations) => {
      const titleLabel: string = translations['REVIEW_ALERT.TITLE'];
      const message: string = translations['REVIEW_ALERT.MESSAGE'];
      const laterLabel: string = translations['REVIEW_ALERT.BUTTON_LATER'];
      const goLabel: string = translations['REVIEW_ALERT.BUTTON_GO'];
      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        cssClass: 'start-content-alert-class',
        header: titleLabel,
        message: message,
        buttons: [
          {
            text: laterLabel,
            role: 'cancel',
            handler: (): void => {
              this.markLaunchReviewDone();
            },
          },
          {
            text: goLabel,
            handler: (): void => {
              this.doLaunchReview();
            },
          },
        ],
      });
      alert.present();
    });

  }

  private doLaunchReview(): void {
    console.log("** isSup: "+this.launchReview.isRatingSupported());
    this.markLaunchReviewDone();
    if(this.launchReview.isRatingSupported()){
      this.launchReview.rating().subscribe({
        next(x) {
          console.log('LaunchRating got value ' + x);
        },
        error(err) {
          console.error('LaunchRating something wrong occurred: ' + err);
        },
        complete() {
          console.log('LaunchRating done');
        },
      });
    }else{
      this.launchReview.launch().then(
          (x) => {
              console.log('LaunchReview got value ' + x);
            },
          (err) => {
            console.error('LaunchReview something wrong occurred: ' + err);
          }
      );
    }
  }

  private markLaunchReviewDone(): void {
    this.userService.markLaunchReviewDone().subscribe();
  }

  public checkSeachInput(): void {
    // Android soft keyboard destroys the layout
    if ( this.platform.is('capacitor') && this.platform.is('android')) {
      this.navService.push('search', {focus: true});
    }    
  }

  public handleSearchInput(event): void {
    if (event.target.value.toLowerCase().trim() != '') {
      this.navService.push('search', {search: event.target.value});
    };
  }

  public log(s) {
    console.log(s);
  }

  // Simple

  public firstDiaTitle() {
    if ( this.infoData && this.infoData.length > 0 ) {
      const item = this.infoData[0];
      if ( item.title ) {
        return item.title;
      }
      console.log("ITEM %o", item);
      return "unkonwn item"
    }
    return '';
  }

  public onSimpleDiaClick(): void {
    if ( this.infoData && this.infoData.length > 0 ) {
      const item = this.infoData[0];
      this.showDialog(item.dialog);
    }
  }

  public onSimpleContentsClick(): void {
    this.navService.push('content');
  }

  public onSimpleSettingsClick(): void {
    this.navService.push('profile/settings');
  }
}
